import getTodoRequestHeaders from './getTodoRequestHeaders';
import {
    GetTodoSettingResponse,
    GetTodoSettingServiceResponse,
} from './GetTodoSettingServiceResponse';
import { makeGetRequest } from 'owa-ows-gateway';
import { TODO_API_GET_SETTINGS } from './constants';

export default async function getTodoSettingsService(): Promise<GetTodoSettingServiceResponse> {
    return makeGetRequest(
        TODO_API_GET_SETTINGS,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders()
    )
        .then(async (response: Response) => {
            const responseBody = <GetTodoSettingResponse>await response.json();

            return {
                StatusCode: response.status,
                ResponseBody: responseBody,
            };
        })
        .catch(err => {
            return null;
        });
}
